import React, { useState } from "react";
import handleNumericCheck from "../Utils/NumericCheck";
import moment from "moment-mini";
import PropTypes from "prop-types";
import { GoEye, GoEyeClosed } from "react-icons/go";
import { withFeatureSafe } from "Common/ErrorBoundaries";

const UpperCase = (e) => {
  let p = e.target.selectionStart;
  e.target.value = e.target.value.toUpperCase();
  e.target.setSelectionRange(p, p);
};
function CustomInput({
  label,
  required,
  labelClass = "",
  maxFloat,
  isNumeric,
  isFloat,
  allowNegative,
  extraClass,
  type,
  suffixImg,
  prefixImg,
  SuffixIcon,
  onKeyPress,
  onChange,
  PrefixIcon,
  SuffixIconClass,
  name,
  toLower = false,
  ...inputProps
}) {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="flex relative flex-col w-full">
      {label && (
        <label
          className={`text-secondary  mb-2 font-medium text-sm ${labelClass} ${required && " required"
            }`}
        >
          {label}
        </label>
      )}
      <div className="flex relative w-full">
        {SuffixIcon && (
          <SuffixIcon
            className={`absolute text-primaryColor text-2xl left-[.4rem] top-1/2 -translate-y-1/2 ${SuffixIconClass}`}
          />
        )}
        <img
          src={prefixImg}
          alt=""
          className={`absolute  left-[.3rem] top-1/2 -translate-y-1/2 ${SuffixIconClass}`}
        />
        <input
          type={showPassword ? "text" : type}
          autoComplete="off"
          onPaste={
            type === "date"
              ? (e) => {
                const pastedDate = e.clipboardData.getData("text/plain");
                let trimeddate = pastedDate.trim();
                const formattedDate = moment(trimeddate).format("YYYY-MM-DD");
                onChange({ target: { value: formattedDate, name: name } });
              }
              : (e) => {
                const pastedValue = e.clipboardData.getData("text/plain");
                let trimmedValue = pastedValue.trim();
                if (isNumeric) {
                  // If pasted value starts with '.' and not '0.', prepend '0'
                  if (trimmedValue.startsWith('.') && !trimmedValue.startsWith('0.')) {
                    trimmedValue = '0' + trimmedValue;
                  }
                  // Prevent double 0s before period
                  if (trimmedValue.startsWith('00.')) {
                    trimmedValue = '0.' + trimmedValue.slice(3);
                  }
                  const regex = new RegExp(`^-?\\d+(\\.\\d{0,2})?$`);
                  if (
                    regex.test(trimmedValue) ||
                    trimmedValue === "-" ||
                    trimmedValue === ""
                  ) {
                    onChange({
                      target: {
                        value: trimmedValue,
                        name: name,
                        dataset: e.target.dataset,
                      },
                    });
                    e.preventDefault();
                    return true;
                  } else {
                    e.preventDefault();
                    return false;
                  }
                } else {
                  onChange({
                    target: {
                      value: trimmedValue,
                      name: name,
                      dataset: e.target.dataset,
                    },
                  });
                  e.preventDefault();
                }
              }
          }
          onKeyPress={
            isNumeric
              ? (e) => {
               
                if (e.key === '.' && e.target.selectionStart === 0) {
                  e.preventDefault();
                  if (!e.target.value.startsWith('0.')) {
                    const newValue = '0.' + e.target.value;
                    onChange({
                      target: {
                        value: newValue,
                        name: name,
                        dataset: e.target.dataset,
                      },
                    });
 
                    setTimeout(() => {
                      e.target.setSelectionRange(2, 2);
                    }, 0);
                  }
                  return;
                }
                handleNumericCheck(
                  e,
                  isFloat ? "allowFloat" : "",
                  maxFloat,
                  allowNegative
                );
                if (onKeyPress) {
                  onKeyPress(e);
                }
              }
              : onKeyPress
                ? onKeyPress
                : () => { }
          }
          // (e) => {
          // let p = e.target.selectionStart;
          // e.target.value = e.target.value.toUpperCase();
          // e.target.setSelectionRange(p, p);
          // }
          onInput={
            type === "date"
              ? () => { }
              : toLower
                ? (e) => (e.target.value = "" + e.target.value)
                : type !== "number" && type !== "email"
                  ? UpperCase
                  : (e) => (e.target.value = "" + e.target.value)
          }
          {...inputProps}
          name={name}
          onChange={(e) => {
            const raw = e.target?.value ?? '';
            const trimmedStart = type === 'date' ? raw : raw.trimStart();
            if (trimmedStart !== raw) {
              e = { ...e, target: { ...e.target, value: trimmedStart, name } };
            }
            onChange(e);
          }}
          className={` p-[0.4rem] py-[.3rem] max-h-[29px] w-full focus:shadow-md !shadow-primaryColor/10 focus:border-primaryColor border  text-base focus:outline-none focus:ring-0  rounded text-gray-900  disabled:bg-gray-50  ${extraClass}
        
        
        ${PrefixIcon && "pr-8 "}
        ${SuffixIcon && "pl-8 "}
        ${prefixImg && "pl-6"}
        ${suffixImg && "pr-4"}
        `}
        />

        {PrefixIcon && (
          <PrefixIcon className="absolute text-primaryColor text-2xl right-[.3rem] top-1/2 -translate-y-1/2" />
        )}
        <img
          src={suffixImg}
          alt=""
          className="absolute right-[.3rem] top-1/2 -translate-y-1/2"
        />
        {type === "password" && (
          <button onClick={() => setShowPassword(!showPassword)} type="button">
            {showPassword ? (
              <GoEye
                className="absolute right-1 top-1/2 opacity-100 -translate-x-1/2 -translate-y-1/2 size-6 text-primaryColor"
              />
            ) : (
              <GoEyeClosed
                className="absolute right-1 top-1/2 opacity-50 -translate-x-1/2 -translate-y-1/2 size-6 text-primaryColor"
              />
            )}
          </button>
        )}
      </div>
    </div>
  );
}

export default withFeatureSafe(CustomInput);
CustomInput.propTypes = {
  configData: PropTypes.object.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  labelClass: PropTypes.string,
  maxFloat: PropTypes.number,
  isNumeric: PropTypes.bool,
  isFloat: PropTypes.bool,
  allowNegative: PropTypes.bool,
  extraClass: PropTypes.string,
  type: PropTypes.string,
  suffixImg: PropTypes.string,
  prefixImg: PropTypes.string,
  SuffixIcon: PropTypes.element,
  onKeyPress: PropTypes.func,
  onChange: PropTypes.func,
  PrefixIcon: PropTypes.element,
  SuffixIconClass: PropTypes.string,
  name: PropTypes.string,
  toLower: PropTypes.bool,
};
